<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="carfutures-card-header" class="pl-2 pr-3 small">
        Future Car Pickups
        <!-- <div class="card-header-actions">
          {{ carfutures.timestamp }}
          <span
            id="carfutures_ago"
            :class="'ml-2 status-dot ' + lastrunstatus"
            pulse="true"
          ></span>
        </div> -->
      </b-card-header>
      <b-tooltip target="carfutures-card-header" triggers="hover"
        >Car Pickups in the future</b-tooltip
      >
      <!-- <b-tooltip target="carfutures_ago" triggers="hover"
        >last run
        {{
          $moment(carfutures.timestamp, "DD/MM/YYYY HH:mm:SS") | formatTimeago
        }}</b-tooltip
      > -->
      <b-card-body class="px-0 pt-0">
        <b-table
          v-if="options.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="205px"
          fixed
          small
          bordered
          :items="items"
          :fields="options.fields"
          class="gridtable my-0"
        >
          <template v-slot:cell()="row">
            <div
              v-if="
                options.badges &&
                options.badges.find((obj) => obj.key == row.field.key)
              "
            >
              <span
                v-html="
                  $helpers.badgeField(
                    row.item,
                    options.badges.find((obj) => obj.key == row.field.key),
                    options
                  )
                "
              ></span>
            </div>
            <div v-else>{{ row.value }}</div>
          </template>
        </b-table>
        <b-row class="excelsheetbuttons">
          <!-- <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="carfutures_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="carfutures_log" triggers="hover"
                >Show list</b-tooltip
              >
            </b-button-group>
          </b-col> -->
          <b-col class="text-right">
            <b-link
              id="carfutures-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="carfutures-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ options.items.length }} future booking(s)</span
            >
            <br />
            <span v-if="!busy" class="small text-primary">{{
              options.actionmessage
            }}</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "CarFutures",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "CarFutures",
      options: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        running: false,
        actionmessage: "",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "pickupdate",
            label: "Pickup Date",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "pickuplocation",
            label: "Pickup Location",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
          {
            key: "driver",
            label: "Driver",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
          {
            key: "slac",
            label: "S/L",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "w-75pct",
          },
        ],
        items: [
          {
            updated_at: this.$moment().format("x") / 1000,
            name: "Log4Net test message",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Invoiced: "primary",
            Cancelled: "danger",
            New: "info",
            Pending: "warning",
            Failed: "danger",
            Vouchered: "warning",
            Queued: "secondary",
            "On Hold": "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "ID":
                  return "Invoiced";
                  break;
                case "AA":
                  return "On Hold";
                  break;
                case "CX":
                  return "Cancelled";
                  break;
                case "IF":
                  return "Failed";
                  break;
                case "IQ":
                  return "Queued";
                  break;
                case "ST":
                  return "New";
                  break;
                case "VD":
                  return "Vouchered";
                  break;
                case "WI":
                  return "Pending";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.options.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
    lastrunstatus() {
      let result = "danger";
      // if (this.nlpost.timestamp != "Unknown") {
      //   let minutes = this.$moment().diff(
      //     this.$moment(this.nlpost.timestamp, "DD/MM/YYYY HH:mm:SS"),
      //     "minutes"
      //   );
      //   if (minutes <= 1440) {
      //     result = "success";
      //   } else if (minutes > 1440 && minutes < 2880) {
      //     result = "warning";
      //   } else {
      //     result = "danger";
      //   }
      // }
      return result;
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: carfutures");

      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings {
              carbookings(isfuture: "true") {
                pickupdate
                pickuplocation
                slac
                eventcode
                driver
                status
              }
            }
          `,
        });
        console.log(response);
        this.options.items = response.data.carbookings;

        // if (response.data.file_date) {
        //   this.nlpost.timestamp = this.$moment
        //     .unix(response.data.file_date / 1000)
        //     .format("DD/MM/YYYY HH:mm:SS");
        // }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>


<style>
</style>